import React, {Component} from 'react';
var Dropzone = require('react-dropzone');
var async = require('async');
import { UPDATE_ADMIN_PRODUCT_IMAGES,UPDATE_ADMIN_PRODUCT_IMAGE, UPLOAD_ADMIN_PRODUCT_IMAGE, DELETE_ADMIN_PRODUCT_IMAGE} from "actions/actionTypes";

/* drag and drop for images */

import ProductImage from 'dashboard/products/ProductImage.js';
import update from 'react/lib/update';

import {ControlLabel} from 'react-bootstrap';
import withDragAndDropContext from'shared/withDragAndDropContext';

  class AdminProductImageEdit extends Component {

    constructor(props) {
        super(props);
        this.moveImage = this.moveImage.bind(this);
        this.saveImage = this.saveImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
         this.reorderImages = this.reorderImages.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.state = {
            images: _.get(this.props.currentProduct, 'OriginalImages', []),
            pending: false,
        };
    }



    moveImage(dragIndex, hoverIndex) {
        const {images} = this.state;
        const dragProductImage = images[dragIndex];
        //const hoverProductImage = images[hoverIndex];
        this.setState(update(this.state, {
            images: {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragProductImage],
                ],
            },
        }));
    }

      reorderImages() {
        this.setState({pending: true});
        var self = this;
        var images = _.map(this.state.images, '_id');
        this.props.reorderImages({'images': images}, {
            'productID': this.props.currentProduct._id,
            'success_event_data': {
                'productID': this.props.currentProduct._id
            }
        }).then(function (response) {
            self.setState({pending: false});
        }).catch(function (response) {
            self.setState({pending: false});
        })
    }

    saveImage(image) {
         var imageData = _.pick(image, ['Caption']);
        var methodData = {
            "type":'patch',
            'endpoint': '/products/' + encodeURIComponent(this.props.currentProduct._id) + '/images/'+ encodeURIComponent(image._id),
            'success_event': UPDATE_ADMIN_PRODUCT_IMAGE,
            'messageData': {'#1#': 'Image'},
            messageCode:'recordUpdated',
            'success_event_data': {
                'productID': this.props.currentProduct._id,
            }
        };
        this.props.makeRequest(imageData, methodData).then(function (response) {

        })

    }

    deleteImage(image) {
        this.setState({pending: true});
        var self = this;
         this.props.makeRequest({}, {
            'endpoint': '/products/' + encodeURIComponent(this.props.currentProduct._id) + '/images/' + encodeURIComponent(image._id),
             'messageData': {'#1#': 'Image'},
            type:'delete',
            'success_event_data': {
                'productID': this.props.currentProduct._id,
                'imageID': image._id
            }
        }).then(function (response) {
             var itemIndex = _.findIndex(self.state.images, {'_id': image._id});
             var updatedImages = [...self.state.images.slice(0, itemIndex),
                 ...self.state.images.slice(itemIndex + 1)];

             self.setState({pending: false,images: updatedImages})

        }).catch(function (response) {
            self.setState({pending: false});
        });
    }

    onDrop(acceptedFiles, rejectedFiles) {
        var self = this;
        if (_.size(rejectedFiles) > 0) {
             return self.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFileUpload'
            });
        }

        this.setState({pending: true});
        var functionsToCall = [];
         _.forEach(acceptedFiles, function (file, key) {
            functionsToCall.push(function (done) {
              //  file.firstImageOnCreate = false;
                var highestPositionImages = _.sortBy(self.state.images, function (o) {
                    return o.Position;
                });
                var nextPosition =  !_.isUndefined(_.last(highestPositionImages)) &&!_.isUndefined(_.last(highestPositionImages).Position)   ? parseInt( _.last(highestPositionImages).Position) + 1 : 1
                self.uploadImage(file ,nextPosition, done);
            });
        });
        async.parallel(functionsToCall,
            function (err, uploadResponses) {
                if (err) {

                }
                 self.setState({pending: false});
            });
    }
    uploadImage(file, nextPosition, done) {
        var self = this;
         var data = new FormData();
        data.append('file',file);
        data.append('Position',nextPosition);
         var methodData = {
            "type":'post',
             'endpoint': '/products/' + encodeURIComponent(this.props.currentProduct._id) + '/images/upload',
        //    'success_event': UPLOAD_ADMIN_PRODUCT_IMAGE,
            'messageData': {'#1#': 'Image'},
            'success_event_data': {
                'productID': this.props.currentProduct._id,
            }
         };
        this.props.makeRequest(data, methodData).then(function (response) {
            self.setState({images:_.concat([...self.state.images], [response.data])})
            done(null, response);
        })
    }

    render() {
        return (
            <div style={{position: 'relative'}}>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
                <div className={(this.state.pending ? 'pending' : '')}>
                    {_.map(_.sortBy(this.state.images,  'Position'), (image, i) => (
                        <ProductImage
                            key={image._id}
                            index={i}
                            image={image}
                            moveImage={this.moveImage}
                            deleteImage={this.deleteImage}
                           // addOrDeleteVendorProductImage={this.addOrDeleteVendorProductImage}
                            saveImage={this.saveImage }
                            reorderImages={this.reorderImages}
                            onDrop={this.onDrop}
                        />
                    ))}
                    <div className="clearfix"></div>
                    <div className="top20">
                        <ControlLabel>Upload image</ControlLabel>
                        <Dropzone
                            multiple={true}
                            onDrop={this.onDrop}
                            accept="image/*"
                            maxSize={8388608} // 8mb
                        >
                            <div>Try dropping some files here or click to select files to upload.</div>
                        </Dropzone>

                    </div>
                </div>
            </div >
        );
    }
}
export default withDragAndDropContext(AdminProductImageEdit)


